import { createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2ae561e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "preview" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "preview-annotation" }, "Front view", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "preview-annotation" }, "Side view", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "preview-annotation" }, "Back view", -1))
const _hoisted_5 = { class: "product-info" }
const _hoisted_6 = {
  key: 0,
  class: "product-info-item"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "description" }, "Production time: ", -1))
const _hoisted_8 = { class: "value" }
const _hoisted_9 = {
  key: 1,
  class: "product-info-item"
}
const _hoisted_10 = { class: "value" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "description" }, "Prices start from: ", -1))
const _hoisted_12 = { class: "value" }
const _hoisted_13 = {
  key: 2,
  class: "product-info-item"
}
const _hoisted_14 = ["href"]
const _hoisted_15 = { class: "additional-options-section" }
const _hoisted_16 = { class: "quantity" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Quantity", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "vl" }, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Price", -1))
const _hoisted_20 = {
  key: 0,
  class: "price-tag"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "vl" }, null, -1))
const _hoisted_22 = { class: "save-design-button" }
const _hoisted_23 = { class: "add-to-cart-button" }
const _hoisted_24 = { class: "modal-content" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createTextVNode(" Enter your email "),
  /*#__PURE__*/_createElementVNode("hr")
], -1))
const _hoisted_26 = { class: "modal-body" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " You can save your design and progress, by entering your email address bellow. ", -1))
const _hoisted_28 = { class: "input-container" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Name", -1))
const _hoisted_30 = { class: "error-msg" }
const _hoisted_31 = { class: "input-container" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "lastName" }, "Last Name", -1))
const _hoisted_33 = { class: "error-msg" }
const _hoisted_34 = { class: "input-container" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "email" }, "Email", -1))
const _hoisted_36 = { class: "error-msg" }
const _hoisted_37 = { class: "input-container" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "email" }, "Phone", -1))
const _hoisted_39 = { class: "error-msg" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([
        _ctx.activeProduct.type === 'scarf' ? 'preview-image-wrapper-scarf' : '',
        'preview-image-wrapper',
      ])
    }, [
      _createVNode(_component_swiper, {
        effect: 'cards',
        loop: true,
        grabCursor: true,
        pagination: true,
        navigation: true,
        modules: _ctx.modules
      }, {
        default: _withCtx(() => [
          _createVNode(_component_swiper_slide, null, {
            default: _withCtx(() => [
              _hoisted_2,
              (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.activeProductAlias), {
                id: "svg-front",
                text: _ctx.activeProduct.text,
                productColors: _ctx.activeProduct.colors,
                logo: _ctx.activeProduct.logo,
                cheetaLogo: _ctx.activeProduct.cheetaLogo,
                activePlayer: _ctx.activePlayerView,
                details: _ctx.activeProduct.details
              }, null, 8, ["text", "productColors", "logo", "cheetaLogo", "activePlayer", "details"]))
            ]),
            _: 1
          }),
          (_ctx.activeProduct.type === 'truckercap')
            ? (_openBlock(), _createBlock(_component_swiper_slide, { key: 0 }, {
                default: _withCtx(() => [
                  _hoisted_3,
                  (_openBlock(), _createBlock(_resolveDynamicComponent(`${_ctx.activeProductAlias}_side`), {
                    id: "svg-side",
                    text: _ctx.activeProduct.text,
                    productColors: _ctx.activeProduct.colors,
                    logo: _ctx.activeProduct.logo,
                    cheetaLogo: _ctx.activeProduct.cheetaLogo,
                    activePlayer: _ctx.activePlayerView,
                    details: _ctx.activeProduct.details
                  }, null, 8, ["text", "productColors", "logo", "cheetaLogo", "activePlayer", "details"]))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_swiper_slide, null, {
            default: _withCtx(() => [
              _hoisted_4,
              (_openBlock(), _createBlock(_resolveDynamicComponent(`${_ctx.activeProductAlias}_back`), {
                id: "svg-back",
                text: _ctx.activeProduct.text,
                productColors: _ctx.activeProduct.colors,
                logo: _ctx.activeProduct.logo,
                cheetaLogo: _ctx.activeProduct.cheetaLogo,
                activePlayer: _ctx.activePlayerView,
                details: _ctx.activeProduct.details
              }, null, 8, ["text", "productColors", "logo", "cheetaLogo", "activePlayer", "details"]))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modules"])
    ], 2),
    _createElementVNode("div", _hoisted_5, [
      (_ctx.productSettings && _ctx.productSettings.productionTime)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.productSettings.productionTime), 1),
            _createTextVNode(" | ")
          ]))
        : _createCommentVNode("", true),
      (_ctx.minQty && _ctx.minPrice)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("span", _hoisted_10, "Min " + _toDisplayString(_ctx.minQty) + " units", 1),
            _createTextVNode(" | "),
            _hoisted_11,
            _createElementVNode("span", _hoisted_12, "$" + _toDisplayString(_ctx.minPrice) + " + GST ", 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.pricingPdfUrl)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createElementVNode("a", {
              href: `${_ctx.pricingPdfUrl}`,
              target: "_blank"
            }, "(see pricing)", 8, _hoisted_14)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _hoisted_17,
        _createVNode(_component_InputNumber, {
          disabled: _ctx.isQuantityEditingDisabled,
          "onUpdate:modelValue": [
            _ctx.quantityChanged,
            _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeProduct.quantity) = $event))
          ],
          style: {"width":"100%"},
          modelValue: _ctx.activeProduct.quantity,
          modelModifiers: { lazy: true },
          mode: "decimal",
          min: _ctx.minQty || 1,
          allowEmpty: false
        }, null, 8, ["disabled", "onUpdate:modelValue", "modelValue", "min"])
      ]),
      _hoisted_18,
      _createElementVNode("div", null, [
        _hoisted_19,
        (!_ctx.priceLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, "$" + _toDisplayString(_ctx.price) + " + GST", 1))
          : (_openBlock(), _createBlock(_component_Skeleton, {
              key: 1,
              style: {"height":"24px","margin":"5px 0"}
            }))
      ]),
      _hoisted_21,
      _createElementVNode("div", _hoisted_22, [
        _createVNode(_component_Button, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openSaveDesignDialog = true)),
          label: "SAVE DESIGN"
        })
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createVNode(_component_Button, {
          onClick: _ctx.submitProduct,
          label: _ctx.buttonLabel
        }, null, 8, ["onClick", "label"])
      ])
    ]),
    _createVNode(_component_Dialog, {
      visible: _ctx.openSaveDesignDialog,
      "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.openSaveDesignDialog) = $event)),
      modal: "",
      header: " ",
      style: { width: '60vw' }
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_24, [
          _hoisted_25,
          _createElementVNode("div", _hoisted_26, [
            _hoisted_27,
            _createElementVNode("div", _hoisted_28, [
              _hoisted_29,
              _createVNode(_component_InputText, {
                class: _normalizeClass([_ctx.v$.name.$errors.length ? 'error' : '', 'input']),
                placeholder: "John",
                id: "name",
                modelValue: _ctx.userData.name,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.userData.name) = $event))
              }, null, 8, ["class", "modelValue"]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.name.$errors, (error) => {
                return (_openBlock(), _createElementBlock("small", {
                  class: "input-errors",
                  key: error.$uid
                }, [
                  _createElementVNode("small", _hoisted_30, _toDisplayString(error.$message), 1)
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_31, [
              _hoisted_32,
              _createVNode(_component_InputText, {
                class: _normalizeClass([_ctx.v$.lastName.$errors.length ? 'error' : '', 'input']),
                placeholder: "Doe",
                id: "lastName",
                modelValue: _ctx.userData.lastName,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.userData.lastName) = $event))
              }, null, 8, ["class", "modelValue"]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.lastName.$errors, (error) => {
                return (_openBlock(), _createElementBlock("small", {
                  class: "input-errors",
                  key: error.$uid
                }, [
                  _createElementVNode("small", _hoisted_33, _toDisplayString(error.$message), 1)
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_34, [
              _hoisted_35,
              _createVNode(_component_InputText, {
                class: _normalizeClass([_ctx.v$.email.$errors.length ? 'error' : '', 'input']),
                placeholder: "example@gmail.com",
                id: "email",
                modelValue: _ctx.userData.email,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.userData.email) = $event))
              }, null, 8, ["class", "modelValue"]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.email.$errors, (error) => {
                return (_openBlock(), _createElementBlock("small", {
                  class: "input-errors",
                  key: error.$uid
                }, [
                  _createElementVNode("small", _hoisted_36, _toDisplayString(error.$message), 1)
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_37, [
              _hoisted_38,
              _createVNode(_component_InputText, {
                class: _normalizeClass([_ctx.v$.phone.$errors.length ? 'error' : '', 'input']),
                placeholder: "Enter phone",
                id: "phone",
                modelValue: _ctx.userData.phone,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.userData.phone) = $event))
              }, null, 8, ["class", "modelValue"]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.phone.$errors, (error) => {
                return (_openBlock(), _createElementBlock("small", {
                  class: "input-errors",
                  key: error.$uid
                }, [
                  _createElementVNode("small", _hoisted_39, _toDisplayString(error.$message), 1)
                ]))
              }), 128))
            ]),
            _createVNode(_component_Button, {
              style: _normalizeStyle({
              color: 'rgb(73, 80, 87)',
            }),
              class: "orange-button",
              label: "SAVE",
              loading: _ctx.loadingDesignRequest,
              icon: _ctx.spinnerComputed,
              type: "submit",
              onClick: _ctx.saveDesign
            }, null, 8, ["style", "loading", "icon", "onClick"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}